<template>
    <div class="container-fluid">
        <v-title :lineage="[{'Rules Engine':'rules-engine'}]">
            Value Lists
            <div slot="actions">
                <router-link
                    v-if="$auth.$pages['add-list-item'].isAllowed"
                    :to="{name: 'add-list-item'}"
                    class="btn btn-link">Add List<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
            </div>
        </v-title>
        <grid
            :columns="gridColumns"
            :provider="provider"
            :tabs="gridTabs"
            :filter-set="gridFilterSet"
            @completed="stopLoadingPage">
            <v-no-content slot="no-content">
                <span slot="title">It seems that you have no value lists</span>
                <span slot="description">Click on the button below to add your first value list.</span>
                <div slot="actions">
                    <router-link
                        v-if="$auth.$pages['add-list-item'].isAllowed"
                        :to="{name: 'add-list-item'}"
                        class="btn btn-link">Add List<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
                </div>
            </v-no-content>
        </grid>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import {vIcon} from '@/components/form';
    import vNoContent from '@/components/v-no-content';
    import Grid from '@/components/grid/grid';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import TabsConfiguration from '@/components/grid/tabs/tabs-configuration';
    import listFilters from '@/common/query/filter/list-filters';
    import {createDialog, vConfirm} from '@/components/modal/dialogs/index';
    import listsColumns from './lists-columns';
    import FilterSet from '@/components/query/filter-set';

    export default {
        name: 'lists',
        components: {
            vTitle, vIcon, Grid, vNoContent,
        },
        mixins: [LoadStateMixin],
        data() {
            return {
                gridColumns: listsColumns(this.showDeleteListItemDialog),
                gridTabs: new TabsConfiguration({
                    id: 'lists',
                    store: this.$store,
                    systemTabs: [
                        {
                            label: 'All',
                            sortBy: {createdTime: 'desc'},
                        },
                    ],
                    version: 4,
                    filtersVersion: listFilters.version,
                }),
                gridFilterSet: new FilterSet({store: this.$store, ...listFilters}),
            };
        },
        methods: {
            async showDeleteListItemDialog(data, grid) {
                const confirmDialog = createDialog(vConfirm, this);
                const dialogParams = {
                    title: 'Delete List Item',
                    content: 'Are you sure you want to delete this item?',
                    confirmLabel: 'Delete',
                    dangerConfirm: true,
                };
                if (await confirmDialog(dialogParams)) {
                    this.deleteListItem(data, grid);
                }
            },
            async deleteListItem(data, grid) {
                try {
                    const params = {id: data.fields.id};
                    grid.startLoading();
                    await this.$api(({lists}) => lists.delete(params));
                    grid.fetchData();
                    this.$toast.positive('List item successfully deleted');
                } catch (error) {
                    this.$toast.fromError(error);
                    grid.stopLoading();
                }
            },
            provider(params) {
                // prevent download of values by
                // limiting the fields
                params.fields = [
                    'id',
                    'description',
                    'version',
                    'createdTime',
                    'updatedTime',
                ].join(',');
                return this.$api(({lists}) => lists.getAll(params));
            },
        },
    };

</script>
